import React from 'react';
import { ContactInfoFieldKeyType } from 'typings/form';
import { OutlineArrowDownIcon, OutlineArrowUpIcon } from '../icons';
import { ContactPersonData } from '../contactPerson/contactPersonCard';
import { Button, Col, ContactFieldRow, Divider, IconWrapper, Row, Typography } from 'components';
import styles from './styles.module.scss';

interface IType {
  person: ContactPersonData;
  contactEntries: [ContactInfoFieldKeyType, string[]][];
  contactValues: string[][];
  toggleExpandPerson: (personId: string) => void;
  isPersonExpanded: (personId: string) => boolean;
}

export const ContactPersonCard = React.memo<IType>((props: any) => {
  const { person, contactEntries, isPersonExpanded, contactValues, toggleExpandPerson } = props;

  return (
    <React.Fragment key={person.id}>
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row className={styles.name_flag_container} align={'middle'}>
                <Typography.Text type={'secondary'}>{person.fullName}</Typography.Text>
                {person.language?.flagLocation && <IconWrapper src={person.language?.flagLocation} />}
              </Row>
            </Col>
          </Row>
        </Col>

        {person.department && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Typography.Text type={'secondary'}>Department</Typography.Text>
              </Col>
              <Col>
                <Typography.Text type={'secondary'}>{person.department}</Typography.Text>
              </Col>
            </Row>
          </Col>
        )}

        {person.role && (
          <Col span={24}>
            <Row justify={'space-between'}>
              <Col>
                <Typography.Text type={'secondary'}>Role</Typography.Text>
              </Col>
              <Col>
                <Typography.Text type={'secondary'}>{person.role}</Typography.Text>
              </Col>
            </Row>
          </Col>
        )}

        {(isPersonExpanded(person.id) ? contactEntries : contactEntries.slice(0, 3)).map(([type, values]: any) => (
          <ContactFieldRow
            fieldValueMaxWidth={250}
            key={type}
            type={type}
            data={isPersonExpanded(person.id) ? values : values.slice(0, 3)}
          />
        ))}

        {contactValues.length > 3 && (
          <Col span={24}>
            <Row align={'middle'} justify={'end'}>
              <Col>
                <Button
                  type={'link'}
                  variant={'link'}
                  className={styles.see_all_button}
                  onClick={() => toggleExpandPerson(person.id)}
                >
                  {isPersonExpanded(person.id) ? 'See Less' : 'See All'}
                  {isPersonExpanded(person.id) ? (
                    <OutlineArrowUpIcon size={'sm'} color={'#308D82'} />
                  ) : (
                    <OutlineArrowDownIcon size={'sm'} color={'#308D82'} />
                  )}
                </Button>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <Divider className={styles.divider} />
    </React.Fragment>
  );
});
